import { addWeeks, eachDayOfInterval, endOfMonth, endOfWeek, getISODay, isSameDay, lastDayOfWeek, setISODay, startOfDay, startOfMonth, startOfWeek } from 'date-fns';
export var TODAY = startOfDay(new Date());
export var YEARS_PER_PAGE = 12;
export var DAYS_IN_WEEK = 7;
export var DAYS_IN_SIX_WEEKS = 42;
export var MIN_MONTH_DEFAULT = 0;
export var MAX_MONTH_DEFAULT = 11;
export var MIN_YEAR_DEFAULT = 1900;
export var MAX_YEAR_DEFAULT = 3000;
export var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export function getMonthWeekDays(_ref) {
  var trimWeekdays = _ref.trimWeekdays,
      weekStartsOn = _ref.weekStartsOn;
  var weekdays = [].concat(WEEKDAYS);
  var sortedWeekdays = weekdays.concat(weekdays.splice(0, weekStartsOn));
  return sortedWeekdays.map(function (weekday, index) {
    return {
      full: weekday,
      trimmed: trimWeekdays ? weekday.substring(0, parseInt(trimWeekdays, 10)) : weekday
    };
  });
}
export function getMonthWeeks(date, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$forceSixWeeks = _ref2.forceSixWeeks,
      forceSixWeeks = _ref2$forceSixWeeks === void 0 ? true : _ref2$forceSixWeeks,
      _ref2$weekStartsOn = _ref2.weekStartsOn,
      weekStartsOn = _ref2$weekStartsOn === void 0 ? 0 : _ref2$weekStartsOn,
      locale = _ref2.locale;

  var weekOptions = {
    weekStartsOn: weekStartsOn,
    locale: locale
  };
  var monthFirstDate = startOfMonth(date);
  var monthLastDate = endOfMonth(date);
  var monthFirstWeekdayDate = startOfWeek(monthFirstDate, weekOptions);
  var monthLastWeekdayDate = lastDayOfWeek(monthLastDate, weekOptions);
  var currentEndOfWeek = endOfWeek(monthFirstWeekdayDate, weekOptions);
  var days = eachDayOfInterval({
    start: monthFirstWeekdayDate,
    end: monthLastWeekdayDate
  });
  var week = [];

  if (forceSixWeeks && days.length < DAYS_IN_SIX_WEEKS) {
    days = eachDayOfInterval({
      start: monthFirstWeekdayDate,
      end: addWeeks(monthLastWeekdayDate, DAYS_IN_SIX_WEEKS % days.length / DAYS_IN_WEEK)
    });
  }

  return days.reduce(function (weeks, day) {
    week.push(day);

    if (isSameDay(day, currentEndOfWeek)) {
      weeks.push(week);
      week = [];
    } else {
      currentEndOfWeek = endOfWeek(day, weekOptions);
    }

    return weeks;
  }, []);
}
export function getNextOccurrenceOfDay(dayOfWeek) {
  var date = setISODay(TODAY, dayOfWeek);
  return getISODay(TODAY) <= dayOfWeek ? date : addWeeks(date, 1);
}
export function getYears(activeYear) {
  var activeOffset = activeYear % YEARS_PER_PAGE;
  var years = [];

  for (var index = 0; index < YEARS_PER_PAGE; index++) {
    years.push(activeYear - activeOffset + index);
  }

  return years;
}